<template>
  <div class="incomming-tasks mt-1" style="overflow-x: auto; height: calc(100vh - 245px);">
    <div
      v-for="message in messageList"
      :key="message.$key"
      :class="{
        'px-1 pt-1': true,
        'message--sender-other': message.senderUserId !== myUserId,
        'message--sender-me': message.senderUserId === myUserId
      }">

      <chat-item-text
        :message="message"
        :other-user-status="getOtherUser(message.senderUserId)"
        :my-user-status="myUserStatus"
        :contact-id="message.senderUserId /* or me? */"
        :groupable="false" />

    </div>
    <p v-if="direction === 'outgoing'" class="no-content">
      Not implemented yet :-(
    </p>
  </div>
</template>

<script>
import ChatItemText from './Elements/ChatItemText'

export default {
  props: {
    direction: { default: 'incomming' },
  },
  data: () => ({
  }),
  created() {
    this.$api.contact_add_if_not_cached( this.myUserId );
  },
  mounted() {
  },
  computed: {

    myUserId() {
      return this.$models.user.defaultUserId;
    },

    myUserStatus() {
      return this.$models.userContact.get_contact_by_id( this.myUserId ) || {
        displayName: 'loading...',
        profilePic: null
      }
    },

    messageList() {
      if ( this.direction === 'incomming' ) {
        return this.incommingMessages.itemsAsArray();
      }
      if ( this.direction === 'outgoing' ) {
        return [] // this.outgoingMessages.itemsAsArray();
      }
      return null
    },

    outgoingMessages() {
      // TODO: loop through all contacts
      // PROBLEM: If we filter by type, we can not filter by sender (me)
      /*
      return this.$models.userMsgInbox
        .with({ uid: this.contactId })
        .subscribeList({
          key: 'type',
          value: 'TASK',
          limit: -101,
        })
      */
      return []
    },

    incommingMessages() {
      return this.$models.userMsgInbox.subscribeQuery({
        key: 'type',
        value: 'TASK',
        limit: -101,
      });
    },

    ready() {
      return this.incommingMessages.$readyAll
    },

    /*
    contactsSorted() {
      return this.userContacts.itemsAsArray();
    },

    userContacts() {
      // TODO: Show other user as pending, when not confirmed
      return this.$models.userContact.subscribeList();
    }
    */
  },
  methods: {
    getOtherUser( contactId ) {
      this.$api.contact_add_if_not_cached( contactId );
      return this.$models.userContact.get_contact_by_id( contactId );
    }
  },
  components: {
    ChatItemText,
  }
};
</script>
